<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<button class="minimizebutton lower"
    [ngbTooltip]="isMinimized ? 'Click to show all information.' : 'Click to show compact information.'"
    [ngClass]="{'fancy-button':isMinimized}" (click)="minimize()">
    <i class='bi-arrows-collapse' *ngIf="isMinimized"></i>
    <i class='bi-arrows-expand' *ngIf="!isMinimized"></i>
</button>
<div id="familiar-height" class="itembox vlist">
    <button class="itembox-close-button list-item center-aligned" (click)="toggleFamiliarMenu()">
        <header class="sectionHeader">Back to Character Sheet</header>
    </button>
    <div class="loading" *ngIf="stillLoading">Loading</div>
    <div class="familiar-box"
        *ngIf="!stillLoading && character.class && isFamiliarAvailable && familiarMenuState==='in'">
        <!--Desktop-only view-->
        <ng-container *ngIf="!isMobile">
            <app-effects [creature]="creatureTypesEnum.Familiar" id="Familiar-effects"
                class="charactersheet-app charactersheet-row mobile-hide">
            </app-effects>
            <div class="charactersheet-column-container mobile-hide">
                <div class="charactersheet-column">
                    <app-general [creature]="creatureTypesEnum.Familiar" id="Familiar-general"
                        class="charactersheet-app"></app-general>
                    <app-familiarabilities id="familiarabilities" class="charactersheet-app">
                    </app-familiarabilities>
                    <app-health [creature]="creatureTypesEnum.Familiar" id="Familiar-health" class="charactersheet-app">
                    </app-health>
                    <app-skills [creature]="creatureTypesEnum.Familiar" id="Familiar-skills" class="charactersheet-app">
                    </app-skills>
                </div>
                <div class="charactersheet-column">
                    <app-defense [creature]="creatureTypesEnum.Familiar" id="Familiar-defense"
                        class="charactersheet-app"></app-defense>
                    <app-inventory [creature]="creatureTypesEnum.Familiar" id="Familiar-inventory"
                        class="charactersheet-app"></app-inventory>
                </div>
            </div>
        </ng-container>
        <!--Mobile-only buttons and views-->
        <ng-container *ngIf="isMobile">
            <div class="charactersheet-app charactersheet-row desktop-hide" id="mobile-tabs">
                <button [ngClass]="{'fancy-button':shownMode()===''}" (click)="toggleShownMode('')">
                    <i class="bi-info-circle-fill"></i>
                </button>
                <button [ngClass]="{'fancy-button':shownMode()==='Health'}" (click)="toggleShownMode('Health')">
                    <i class="ra ra-health"></i>
                </button>
                <button [ngClass]="{'fancy-button':shownMode()==='Defense'}" (click)="toggleShownMode('Defense')">
                    <i class="ra ra-shield"></i>
                </button>
                <button [ngClass]="{'fancy-button':shownMode()==='Skills'}" (click)="toggleShownMode('Skills')">
                    <i class="ra ra-muscle-up"></i>
                </button>
                <button [ngClass]="{'fancy-button':shownMode()==='Actions'}" (click)="toggleShownMode('Actions')">
                    <app-actionIcons [actionString]="'1A'" style="margin:.12rem -.16rem -.14rem -.16rem">
                    </app-actionIcons>
                </button>
                <button [ngClass]="{'fancy-button':shownMode()==='ConditionsEffects'}"
                    (click)="toggleShownMode('ConditionsEffects')">
                    <i class="ra ra-lightning-bolt"></i>
                </button>
            </div>
            <ng-container *ngIf="!stillLoading">
                <div class="charactersheet-column-container desktop-hide">
                    <div class="charactersheet-column">
                        <app-general id="Character-general" class="charactersheet-app"
                            [creature]="creatureTypesEnum.Familiar" [ngClass]="{'minimized':(isMinimized)}"
                            *ngIf="!shownMode() || !['Health','Defense','Attacks','Spells','Skills','Actions','Inventory','ConditionsEffects'].includes(shownMode())">
                        </app-general>
                        <app-familiarabilities id="familiarabilities" class="charactersheet-app" *ngIf="!shownMode()">
                        </app-familiarabilities>
                        <app-health id="Character-health" class="charactersheet-app"
                            [creature]="creatureTypesEnum.Familiar" [showMinimizeButton]="(shownMode() !== 'Downtime')"
                            [ngClass]="{'minimized':(isMinimized || (shownMode() === 'Downtime'))}"
                            *ngIf="shownMode()==='Health'">
                        </app-health>
                        <app-defense id="Character-defense" class="charactersheet-app"
                            [creature]="creatureTypesEnum.Familiar" [ngClass]="{'minimized':(isMinimized)}"
                            *ngIf="shownMode()==='Defense'">
                        </app-defense>
                        <app-skills id="Character-skills" class="charactersheet-app"
                            [creature]="creatureTypesEnum.Familiar" [ngClass]="{'minimized':(isMinimized)}"
                            *ngIf="shownMode()==='Skills'">
                        </app-skills>
                        <app-activities id="Character-activities" class="charactersheet-app"
                            [creature]="creatureTypesEnum.Familiar" [ngClass]="{'minimized':(isMinimized)}"
                            *ngIf="shownMode()==='Actions'">
                        </app-activities>
                        <app-effects id="Character-effects" class="charactersheet-app"
                            [creature]="creatureTypesEnum.Familiar" [fullDisplay]="true"
                            *ngIf="shownMode()==='ConditionsEffects'">
                        </app-effects>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
